import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Pagination } from "antd";
import CustomTabs from "components/tabs/customTab";
import OvertimeRequestCard from "./OvertimeRequestCard";
import {
  getOvertimeList
} from "../../../../../redux/overtime/overtimeState";
import { displayIcon } from "variables/icons";

const TabLabel = ({ text, count }) => (
  <div className="flex items-center justify-center gap-2">
    <span className="text-sm font-medium">{text}</span>
    <Badge
      count={count}
      style={{
        backgroundColor: text === "Pending" ? "#ff0000" : "#fff",
        color: text === "Pending" ? "#fff" : "#000",
        border: "1px solid #d9d9d9",
        
      }}
    />
  </div>
);

const OvertimeRequestTab = ({  }) => {

  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Pending");
  const [statusId, setStatusId] = useState(66);

  const recordList = useSelector((state) => state.overtime?.overtimeList?.items);
  const pagination = useSelector((state) => state.overtime.overtimeList?.pagination);
  const recordData = useSelector((state) => state.overtime.overtimeList);
  const recordStat = useSelector((state) => state.overtime.overtimeStat.data);
  const filters = useSelector((state) => state.overtime.overtimeList.filters);

  const doSearch = (filters) => dispatch(getOvertimeList(filters));

  const tabOptions = [
    { label: <TabLabel text="Pending" count={recordStat?.pending} />, value: "Pending" },
    { label: <TabLabel text="Approved" count={recordStat?.approved} />, value: "Approved" },
    { label: <TabLabel text="Rejected" count={recordStat?.rejected} />, value: "Rejected" },
  ];

  const onTabChange = (value) => {
    setActiveTab(value);
    if (value === "Approved") setStatusId(67);
    else if (value === "Rejected") setStatusId(68);
    else setStatusId(66);
  };

  const EmptyStateIcon = ({ tab }) => {
      const iconMap = {
        Approved: "CircleCheck",
        Rejected: "CircleX",
        Pending: "CircleAlert"
      };

      return displayIcon(
        iconMap[tab],
        "w-12 h-12 text-slate-700 mx-auto mb-4 dark:text-slate-100"
      );
  };

  useEffect(() => {
    dispatch(getOvertimeList({
      ...(filters || {}),
      page: 1,
      paginate: pagination?.per_page || 10, 
      status_id: statusId,
    }));
  }, [dispatch, statusId]);

  return (
    <div className="flex flex-col gap-2">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={onTabChange}
      />

      <div className="flex-1 outline-none mt-6">
        <div className="">
          <div className="space-y-4 pr-4">
            {recordList && recordList.length > 0 ? (
              recordList?.map((item) => <OvertimeRequestCard key={item.id} {...item} />)
            ) : (
              <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border dark:bg-black/5">
                <div className="px-6 pb-6 py-12 text-center">
                  <EmptyStateIcon tab={activeTab} />
                  <p className="text-slate-700 font-medium  dark:text-slate-100">
                    No {activeTab.toLowerCase()} requests found
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="flex justify-end py-4">
            <Pagination
              current={pagination?.current_page }
              pageSize={pagination?.per_page}
              total={pagination?.total}
              showSizeChanger={false}
              onChange={(page) =>
                doSearch({
                  ...filters,
                  page,
                  paginate: pagination.per_page,
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OvertimeRequestTab;
